import format from "date-fns/format";
import useApiRequest from "../../../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../../../api/apiRoutes";
import { setBasketItemLimited } from "../../../../../models/BasketItem";
import useFacility from "../../../../../../utils/hooks/useFacility";
import { BasketItem } from "../../../../../models/BasketItem";
import useBasketManager from "../useBasketManager";
import { useState } from "react";

export default function useBasketSocks() {
  const { post } = useApiRequest();
  const facilityIds = useFacility();
  const { getBasket } = useBasketManager();
  const [socks, setSocks] = useState<number>(0);
  const [tickets, setTickets] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const addGuideToBasket = async (ids: number, qnt: number) => {
    setLoading(true);
    const formattedDate = format(new Date(), "yyyy-MM-dd");
    const { isError } = await post(ADD_TO_BASKET_URL, {
      ...setBasketItemLimited(facilityIds, `0,+${ids}`, formattedDate, qnt, []),
    });
    setLoading(false);
  };

  const addSocks = async (basketList: BasketItem[]) => {
    let bilety: number = 0;
    let socks: number = 0;
    basketList.map((item: BasketItem) => {
      if (
        item.assortName !== "SKARPETKI ANTYPOŚLIZGOWE" &&
        item.assortName !== "KARTA PODARUNKOWA" &&
        item.assortName !== "KARTA PODARUNKOWA GRUPA 4 OSOBY" &&
        item.assortName !== "KARTA PODARUNKOWA Z TRENEREM" &&
        item.assortName !== "Karta Podarunkowa 70 min." &&
        item.assortName !== "Karta Podarunkowa 130 min." && 
        item.assortName !== "Karta Podarunkowa No Limit" &&
        item.assortName !== "Karta Podarunkowa dla 4 osób 70 min." &&
        item.assortName !== "Karta Podarunkowa dla 4 osób 130 min." &&
        item.assortName !== "PRZEDSPRZEDAŻ - Happy Nocka" &&
        item.assortName !== "Happy Nocka" &&
        item.assortName !== "KARTA PODARUNKOWA Z TRENEREM"

      ) {
        bilety = bilety + item.qnt;
      }
      if (item.assortName === "SKARPETKI ANTYPOŚLIZGOWE") {
        socks = socks + item.qnt;
      }
    });

    setTimeout(() => {
      // 21/

      if (bilety - socks > 0) {
        if (facilityIds === "1227") {
          addGuideToBasket(21, bilety - socks);
        }
        if (facilityIds === "1200") {
          addGuideToBasket(167, bilety - socks);
        }
        if (facilityIds === "1204") {
          addGuideToBasket(167, bilety - socks);
        }
        
      }
    }, 100);
    
  };

  return {
    addSocks,
    loading
  };
}
